import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useSiteConfig } from "../context/SiteConfigContext";
import { CategoryContext } from "../context/CategoryContext";
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  return (
    <footer className="luxury-footer">
      <div className="container">
        <div className="row g-4 text-center-mobile">
          {/* Column 1: Brand Pitch */}
          <div className="col-lg-4 col-md-6">
            <Link to="/">
              <img
                src={config?.logo}
                alt="logo"
                style={{ maxHeight: "60px", marginBottom: "20px" }}
              />
            </Link>
            <p className="footer-desc">
              {config?.description ||
                "Curation of international masterclasses and luxury labels right at your doorstep."}
            </p>
            <div className="social-holder justify-content-center justify-content-md-start">
              {config?.socialMedia?.facebook && (
                <a href={config.socialMedia.facebook} className="social-icon">
                  <FaFacebook />
                </a>
              )}
              {config?.socialMedia?.instagram && (
                <a href={config.socialMedia.instagram} className="social-icon">
                  <FaInstagram />
                </a>
              )}
              {config?.socialMedia?.twitter && (
                <a href={config.socialMedia.twitter} className="social-icon">
                  <FaTwitter />
                </a>
              )}
              {config?.socialMedia?.linkedin && (
                <a href={config.socialMedia.linkedin} className="social-icon">
                  <FaLinkedin />
                </a>
              )}
            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-6">
            <h4 className="footer-heading">Quick Access</h4>
            <ul className="footer-links-list">
              <li>
                <Link to="/" className="footer-link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="footer-link">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/shop" className="footer-link">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/contact-us" className="footer-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 2: Dynamic Categories */}
          <div className="col-lg-3 col-md-6 col-6">
            <h4 className="footer-heading">Collections</h4>
            <ul className="footer-links-list">
              {categories?.slice(0, 5).map((cat) => (
                <li key={cat._id}>
                  <Link
                    to={`/categories/${cat.slugPath}`}
                    className="footer-link"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Useful/Assistance Links */}
          <div className="col-lg-2 col-md-6 col-6">
            <h4 className="footer-heading">Assistance</h4>
            <ul className="footer-links-list">
              {/* <li>
                <Link to="/contact-us" className="footer-link">
                  Contact Us
                </Link>
              </li> */}
              <li>
                <Link to="/terms-and-conditions" className="footer-link">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="footer-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/return-and-refund-policy" className="footer-link">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Quick Links (Updated) */}
        </div>

        {/* Bottom Bar */}
        <div className="row g-3 g-md-0 footer-bottom-bar align-items-center text-center-mobile">
          <div className="col-md-6 text-md-start">
            <p className="copy-text">
              &copy; {new Date().getFullYear()}{" "}
              {config?.companyName || "Vigital India Pvt. Ltd"}. All Rights
              Reserved.
            </p>
          </div>
          <div className="col-md-6 text-md-end d-flex justify-content-center justify-content-md-end">
             <a
                  href="https://axesell.com"
                  className="floating-designer-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="floating-content">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/axesell_logo.png`}
                      className="floating-icon"
                      alt="Axesell"
                    />
                  </div>
                </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
